module.exports = __webpack_public_path__ + "static/img/62-2.2eb73cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/62-2.jpg
// module id = 1VyB
// module chunks = 0